module.exports = __webpack_public_path__ + "static/media/rincon.ce907272.jpg";